// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Catalog Page Base Styles */
.catalog-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, #f8f8f8 50%, #d9d9d9 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.catalog-main {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

/* Catalog Header Section */
.catalog-header {
  text-align: center;
  max-width: 900px;
  margin: 0 auto 4rem;
  padding: 0 2rem;
}

.catalog-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #000000;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.catalog-header p {
  font-size: 1.2rem;
  color: #666666;
  line-height: 1.6;
  margin: 0;
  font-weight: 400;
}

/* Responsive pentru header */
@media (max-width: 1200px) {
  .catalog-header h1 {
    font-size: 2.5rem;
  }
  
  .catalog-header p {
    font-size: 1.1rem;
  }
}

@media (max-width: 968px) {
  .catalog-main {
    padding-top: 1.5rem;
  }
  
  .catalog-header {
    margin-bottom: 3rem;
    padding: 0 1rem;
  }
  
  .catalog-header h1 {
    font-size: 2.2rem;
  }
  
  .catalog-header p {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .catalog-header h1 {
    font-size: 2rem;
  }
  
  .catalog-header p {
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .catalog-main {
    padding-top: 1rem;
  }
  
  .catalog-header {
    margin-bottom: 2rem;
  }
  
  .catalog-header h1 {
    font-size: 1.8rem;
    line-height: 1.3;
  }
  
  .catalog-header p {
    font-size: 0.9rem;
  }
}

/* Global animations și effects */
.catalog-page * {
  box-sizing: border-box;
}

/* Smooth scroll behavior */
html {
  scroll-behavior: smooth;
}

/* Focus styles pentru accessibility */
.catalog-page button:focus,
.catalog-page a:focus {
  outline: 2px solid #8b6f47;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Catalog.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,0EAA0E;EAC1E,uGAAuG;AACzG;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* Modern Catalog Page Base Styles */\n.catalog-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #ffffff 0%, #f8f8f8 50%, #d9d9d9 100%);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n}\n\n.catalog-main {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n/* Catalog Header Section */\n.catalog-header {\n  text-align: center;\n  max-width: 900px;\n  margin: 0 auto 4rem;\n  padding: 0 2rem;\n}\n\n.catalog-header h1 {\n  font-size: 2.8rem;\n  font-weight: 700;\n  color: #000000;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n}\n\n.catalog-header p {\n  font-size: 1.2rem;\n  color: #666666;\n  line-height: 1.6;\n  margin: 0;\n  font-weight: 400;\n}\n\n/* Responsive pentru header */\n@media (max-width: 1200px) {\n  .catalog-header h1 {\n    font-size: 2.5rem;\n  }\n  \n  .catalog-header p {\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 968px) {\n  .catalog-main {\n    padding-top: 1.5rem;\n  }\n  \n  .catalog-header {\n    margin-bottom: 3rem;\n    padding: 0 1rem;\n  }\n  \n  .catalog-header h1 {\n    font-size: 2.2rem;\n  }\n  \n  .catalog-header p {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .catalog-header h1 {\n    font-size: 2rem;\n  }\n  \n  .catalog-header p {\n    font-size: 0.95rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .catalog-main {\n    padding-top: 1rem;\n  }\n  \n  .catalog-header {\n    margin-bottom: 2rem;\n  }\n  \n  .catalog-header h1 {\n    font-size: 1.8rem;\n    line-height: 1.3;\n  }\n  \n  .catalog-header p {\n    font-size: 0.9rem;\n  }\n}\n\n/* Global animations și effects */\n.catalog-page * {\n  box-sizing: border-box;\n}\n\n/* Smooth scroll behavior */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Focus styles pentru accessibility */\n.catalog-page button:focus,\n.catalog-page a:focus {\n  outline: 2px solid #8b6f47;\n  outline-offset: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
